import { useScrollReveal } from "../useScrollReveal";
import "./Es3Room.css";

const ROWS = [
  {
    img: "/image/es3/room-counter.jpg",
    alt: "The counter under the amber window",
    stamp: "EX 07",
    title: <>The <em>coffee bar</em></>,
    desc: "Fresh coffee and fresh bread under the amber glow of the boutique window. The smell that pulls you down the stairs and the seat that keeps you here longer than you planned.",
  },
  {
    img: "/image/es3/room-shelves.jpg",
    alt: "The stepped display shelves",
    stamp: "EX 08",
    title: <>The <em>shelves</em></>,
    desc: "Stepped displays and warm spotlights, each with a blank label beside it. They are not empty. They are waiting for whatever you make.",
  },
  {
    img: "/image/es3/room-gallery.jpg",
    alt: "The checkerboard gallery wall",
    stamp: "EX 09",
    title: <>The <em>gallery wall</em></>,
    desc: "A wall of lit niches, each one carrying a maker's piece. Everything you see is for sale, and every sale goes home with its maker.",
  },
  {
    img: "/image/es3/room-stage.jpg",
    alt: "An acoustic set on the small stage",
    stamp: "EX 10",
    title: <>The <em>stage and studio</em></>,
    desc: "Open mics, live poetry, storytelling nights, screenings. By day the infinity wall shoots content. By night it holds the room's breath.",
  },
];

function RoomRow({ row, index }) {
  const { ref, fromLeft, fromRight, fromDir } = useScrollReveal(0.1);
  const isEven = index % 2 === 1;

  return (
    <div className={`es3-room-row${isEven ? " even" : ""}`} ref={ref}>
      <div className="es3-photo" style={isEven ? fromRight(0) : fromLeft(0)}>
        <img src={row.img} alt={row.alt} loading="lazy" />
        <span className="es3-stamp">{row.stamp}</span>
      </div>
      <div className="es3-room-row-text" style={isEven ? fromLeft(180) : fromRight(180)}>
        <h3 className="es3-room-row-h3">{row.title}</h3>
        <p style={fromDir(320)}>{row.desc}</p>
      </div>
    </div>
  );
}

function Es3Room() {
  const { ref, fromDir } = useScrollReveal(0.1);

  return (
    <section className="es3-section es3-room" id="es3-room">
      <div ref={ref} style={fromDir(0)}>
        <div className="es3-hand">the room</div>
        <h2 className="es3-h2">One basement. <em>Four reasons to come down the stairs.</em></h2>
      </div>
      <div className="es3-room-rows">
        {ROWS.map((row, i) => <RoomRow key={i} row={row} index={i} />)}
      </div>
    </section>
  );
}

export default Es3Room;
